import { Route, Routes } from "react-router-dom";
import EnterpriseList from "./EnterpriseList";
import CompanyPage from "./CompanyPage";
import TeamMember from "./TeamMember";
import JobPost from "./JobPost";
import JobDescription from "./JobDescription";
import CompanyProfile from "./CompanyProfile";

function Enterprise() {
  return (
    <Routes>
      <Route path={"/"} element={<EnterpriseList />} />
      <Route path={"/company/:id"} element={<CompanyPage />} />
      <Route path={"/company/:id/member/:id"} element={<TeamMember />} />
      <Route path={"/company/:id/job/:id"} element={<JobPost />} />
      <Route path={"/company/:id/job-description/:id"} element={<JobDescription />} />
      <Route path={"/company-profile/:id"} element={<CompanyProfile />} />
    </Routes>
  );
}

export default Enterprise;
